module.exports = __webpack_public_path__ + "static/media/ic_advertising_gray.774053e9.svg";